import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { ApiTokenInterface } from '../../../interfaces/interfaces';

export const getAdSpaceApiTokensColumns = (
  setTokenToDelete: (token: ApiTokenInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setTokenToUpdate: (token: ApiTokenInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'userId', headerName: 'User ID', width: 100 },
  { field: 'apiToken', headerName: 'API Token', width: 250 }, // should probably be removed or masked in the future (but good during development)
  { field: 'active', headerName: 'Active', width: 90, type: 'boolean' },
  { field: 'validUntil', headerName: 'Valid Until', width: 160 },
  { field: 'created_at', headerName: 'Created', width: 150 },
  { field: 'updated_at', headerName: 'Updated', width: 150 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setTokenToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setTokenToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
];